import { BottomNav, type DefaultNavItem } from "@healthos/ui/shell";

/** Hidden when there is only one place to go, since a nav of one is noise. */
export function OpsBottomNav({ items }: { items: DefaultNavItem[] }) {
  return items.length > 1 ? <BottomNav items={items} /> : null;
}
